const x = {
  none: "0",
  base: "4px",
  lg: "8px",
  "2xl": "16px",
  full: "9999px"
};
export {
  x as default
};
